import React from "react";
import { Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useWindowSize } from "@uidotdev/usehooks";
import { useViewer } from "../../context/ViewerContext";

const ImagePlaceholder = ({
	height = "100%",
	onClick,
	onDrop,
	style = {},
	showText = true,
}) => {
	const size = useWindowSize();
	const isViewer = useViewer();
	const showPlaceholderText = showText && !isViewer;

	// En el viewer no mostramos nada de edición: ni icono, ni borde, ni texto
	if (isViewer) {
		return (
			<div
				data-image-placeholder
				data-template-item
				style={{
					width: "100%",
					height: height,
					position: "relative",
					zIndex: 1001,
					pointerEvents: "none",
					...style,
				}}
			/>
		);
	}

	return (
		<div
			data-image-placeholder
			data-template-item
			style={{
				width: "100%",
				height: height,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				border: "2px dashed rgba(47, 127, 224, 0.4)",
				cursor: "pointer",
				backgroundColor: "rgba(248, 250, 252, 0.8)",
				transition: "all 0.2s ease",
				position: "relative",
				zIndex: 1001, // Asegurar que esté por encima del canvas (z-index 1000)
				pointerEvents: "auto", // Asegurar que pueda recibir eventos
				...style,
			}}
			onClick={onClick}
			onMouseEnter={(e) => {
				e.currentTarget.style.borderColor = "rgba(47, 127, 224, 0.7)";
				e.currentTarget.style.backgroundColor = "rgba(47, 127, 224, 0.05)";
			}}
			onMouseLeave={(e) => {
				e.currentTarget.style.borderColor = "rgba(47, 127, 224, 0.4)";
				e.currentTarget.style.backgroundColor = "rgba(248, 250, 252, 0.8)";
			}}
		>
			<UploadFileIcon
				sx={{
					fontSize: size.width < 600 ? "clamp(24px, 6vw, 80px)!important" : 32,

					color: "rgba(47, 127, 224, 0.6)",

					marginBottom: 0,
				}}
			/>
			{showPlaceholderText && (
				<>
					<Typography
						sx={{
							fontSize:
								size.width < 600 ? "clamp(12px, 3.5vw, 32px)!important" : "12px!important",
							color: "rgba(15, 23, 42, 0.7)",
							fontWeight: 600,
							marginTop: 0,
							textAlign: "center",
						}}
					>
						Haz clic para añadir imagen
					</Typography>
				</>
			)}
		</div>
	);
};

export default ImagePlaceholder;
